import * as z from "zod/v4";
export const IntegrationTypeSchema = z.enum([
    "META",
    "GA4",
    "KLAVIYO",
    "POSTSCRIPT",
    "SNAPCHAT",
    "TIKTOK",
    "GOOGLEADS",
    "SENDLANE",
    "ATTENTIVE",
    "REDO",
    "WEBHOOK",
    "UNSPECIFIED",
]);
//# sourceMappingURL=integration-type.js.map